import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card-header flex justify-between items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Action", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Mark personalized ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Mark regular ")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-project-diagram mr-1" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("  Mapping Selected ")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cubes" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_16 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_slot_error = _resolveComponent("slot-error")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_MapStock = _resolveComponent("MapStock")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.selectedIds?.length > 0)
          ? (_openBlock(), _createBlock(_component_el_dropdown, {
              key: 0,
              trigger: "click",
              placement: "bottom-end"
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, { style: {"min-width":"200px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onUpdatePersonalizeProducts(true))),
                      disabled: _ctx.selectedIds?.length === 0
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_dropdown_item, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onUpdatePersonalizeProducts(false))),
                      disabled: _ctx.selectedIds?.length === 0
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, { type: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectedIds?.length) + " selecteds ", 1),
                    _createVNode(_component_el_divider, { direction: "vertical" }),
                    _hoisted_2,
                    _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_arrow_down)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_5)),
        _createVNode(_component_el_button, {
          onClick: _ctx.handleMapping,
          type: "primary",
          disabled: _ctx.disableMapping,
          size: "small",
          hidden: ""
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.documents,
        lazy: _ctx.isLoading,
        stripe: "",
        fit: "",
        style: {"width":"100%"},
        onSelectionChange: _ctx.handleSelectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            "min-width": 5
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: column.dataIndex,
              prop: column.dataIndex,
              label: column.title,
              "min-width": column.minWidth,
              "tooltip-effect": column.dataIndex,
              align: column.align
            }, {
              default: _withCtx((scope) => [
                (column.dataIndex === 'title')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("a", {
                        onClick: ($event: any) => (_ctx.click(scope.row)),
                        class: "text-primary"
                      }, _toDisplayString(scope.row[column.dataIndex]), 9, _hoisted_9)
                    ]))
                  : (
              column.dataIndex === 'mockup' && scope.row[column.dataIndex]
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (scope.row[column.dataIndex].includes('http'))
                          ? (_openBlock(), _createBlock(_component_el_image, {
                              key: 0,
                              style: {"width":"80px","height":"80px"},
                              src: _ctx.imageUrl(scope.row[column.dataIndex]),
                              fit: "cover"
                            }, {
                              error: _withCtx(() => [
                                _createVNode(_component_slot_error)
                              ]),
                              _: 2
                            }, 1032, ["src"]))
                          : (_openBlock(), _createBlock(_component_el_image, {
                              key: 1,
                              style: {"width":"80px","height":"80px"},
                              src: _ctx.imageUrl(scope.row[column.dataIndex]),
                              "preview-src-list": [_ctx.imageUrl(scope.row[column.dataIndex])],
                              lazy: "",
                              fit: "cover"
                            }, {
                              error: _withCtx(() => [
                                _createVNode(_component_slot_error)
                              ]),
                              _: 2
                            }, 1032, ["src", "preview-src-list"]))
                      ]))
                    : (column.dataIndex === 'createdDate')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.formatDateTime(scope.row[column.dataIndex])), 1))
                      : (column.dataIndex === 'personalized')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(scope.row[column.dataIndex] &&
              scope.row[column.dataIndex] === true
                ? 'Personalized'
                : 'Regular'), 1))
                        : (column.dataIndex === 'action')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              (_ctx.state.mappedUsers)
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.openMapStockDialog(scope.row, _ctx.mappedUser)),
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_14
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_button, {
                                title: "Detail product",
                                size: "small",
                                onClick: ($event: any) => (_ctx.click(scope.row))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_15
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(scope.row[column.dataIndex]), 1))
              ]),
              _: 2
            }, 1032, ["prop", "label", "min-width", "tooltip-effect", "align"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data", "lazy", "onSelectionChange"]), [
        [_directive_loading, _ctx.isLoading]
      ])
    ]),
    _createVNode(_component_MapStock, {
      ref: "mapStockDialog",
      onChange: _ctx.forceUpdate
    }, null, 8, ["onChange"])
  ], 64))
}